<template>
  <div class="row">
    <div class="mb-3 col-auto" >
      <h5>#{{project.id}} No'lu proje</h5>
      <label for="unvan" class="form-label">Başlık</label>
      <input
        type="text"
        class="form-control"
        id="unvan"
        v-model="project.name"
      />
      <label for="description" class="form-label">Açıklama</label>
      <textarea class="form-control" id="description" rows="4" v-model="project.description"></textarea>
      <label for="start_date" class="form-label">Başlangıç</label>
      <input type="date" class="form-control" id="start_date" v-model="project.start_date" />
      <label for="end_date" class="form-label">Bitiş</label>
      <input type="date" class="form-control" id="end_date" v-model="project.end_date" />
      <br/>
      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="project.is_active">
      <label class="form-check-label" for="flexCheckDefault">
          Aktif mi?
      </label><br/><br/>
      <label for="type" class="form-label">Türü</label>
      <select v-model="project.type" id="type" class="form-control form-select">
        <option
          v-for="type in project_types"
          :key="type.id"
          :value="type.id"
        >
          {{ type.name }}
        </option>
      </select>
      <label for="period" class="form-label">Periyod</label>
      <select v-model="project.period" id="period" class="form-control  form-select">
        <option
          v-for="period in this.project_periods"
          :key="period.id"
          :value="period.id"
        >
          {{ period.period }}
        </option>
      </select>
      <label for="client" class="form-label">Müşteri</label>
      <select v-model="project.client_id" id="client" class="form-control">
        <option
          v-for="client in clients"
          :key="client.id"
          :value="client.id"
        >
          {{ client.name }}
        </option>
      </select>
      <br />
      <button class="btn btn-primary btn-block" @click="editClient">
        Duzenle
      </button>
    </div>
  </div>
</template>
<script>
import ClientDataService from "../../services/ClientDataService";
import ProjectDataService from "../../services/ProjectDataService";

import { mapState } from "vuex";

export default {
  name: 'ProjectEdit',
  emits: ["edited"],
  props: ["currentProject"],
  computed: mapState(["project_periods", "project_types"]),
  data() {
    return {
      selected: -1,
      project: this.currentProject,
      clients: []
    };
  },
  created() {
    ClientDataService.getAll().then(response => {
      this.clients = response.data
    }).catch(e => {
      console.log(e.response.data);
        })
    console.log(this.project_types)
  },

  watch: {
    currentProject: function (newV, oldV) {
      this.project = newV;
      
      oldV;
    },
  },
  methods: {
    editClient() {
      let data = {
        name:this.project.name,
        description:this.project.description,
        start_date:this.project.start_date,
        end_date:this.project.end_date,
        is_active:this.project.is_active,
        type:this.project.type,
        period:this.project.period,
        client_id:this.project.client_id,
      }
      ProjectDataService.update(this.project.id, data)
      .then(response => {
        console.log(response.data)
        this.$emit("edited")
        this.$notify({
          text: "Proje Düzenlendi",
          type: "success",
        });
      }).catch(e => {
        console.log(e.response.data)
      })
    },
  },
};
</script>